/*
 *
 * SettingsBankStatementPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 29-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SettingsBankStatementPopup from './SettingsBankStatementPopup'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch)
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SettingsBankStatementPopup)
